import { render } from "./UploadTestReports.vue?vue&type=template&id=baadab80"
import script from "./UploadTestReports.vue?vue&type=script&lang=js"
export * from "./UploadTestReports.vue?vue&type=script&lang=js"

import "./UploadTestReports.vue?vue&type=style&index=0&id=baadab80&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/UploadTestReports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "baadab80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('baadab80', __exports__)) {
    console.log('reload')
    api.reload('baadab80', __exports__)
  }
  
  module.hot.accept("./UploadTestReports.vue?vue&type=template&id=baadab80", () => {
    console.log('re-render')
    api.rerender('baadab80', render)
  })

}


export default __exports__